module.exports = __webpack_public_path__ + "static/media/our-accelerator_JP.8ea54500.svg";